import React, { Component } from 'react';
import {Link}from 'react-router-dom';


import imageSupplier01 from './Logos_Lieferanten/pcam.png';



import { Grid, Row, Col, Breadcrumb} from 'react-bootstrap';

class Aut extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="BCMain">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/Suppliers">Übersicht</Breadcrumb.Item>
            <Breadcrumb.Item active>Automatisierung</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <br/>
        <Grid>
          <Row className="show-grid">
            <Col xs={12}  sm={3}>
                <Link to="/Suppliers/PCAM"><img className="supplierImagesOverview" src={imageSupplier01} alt="Logo PCam" width="100%"/></Link>
            </Col>
            <Col xsHidden  sm={9} className="supplierOverviewDesc">
              <Link to="/Suppliers/PCAM">
              <h3>Automatisierung in ihrer innovativsten Form (Herstellerunabhängig)</h3>
              <h4 className="verticalAlign">Mit Sitz in Tessin (Schweiz) setzt PCam Software- und Hardware-Automatisierungsprojekte mit seinen Kunden seit 1994 um. Neben den ganzheitlichen Automatisierungslösungen aus einer Hand beinhaltet das PCam Produktportfolio ein Prozess- bzw. Feinplanungssystem und  ein CAM-System für den Bereich Senkerosion, Drahtschneiden sowie für das automatisierte Messen im Prozess.</h4>
            </Link>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden className="supplierOverviewDesc">
              <Link to="/Suppliers/PCAM">
              <h4 className="verticalAlign">Automatisierung in ihrer innovativsten Form (Herstellerunabhängig) </h4>
            </Link>
            </Col>
          </Row>
        </Grid>
        <br/>
        <br/>

      </div>
    );
  }
}

export default Aut;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/aut.js